import { render, staticRenderFns } from "./UploadK1Modal.vue?vue&type=template&id=7aa9bda2&scoped=true&"
import script from "./UploadK1Modal.vue?vue&type=script&lang=ts&"
export * from "./UploadK1Modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9bda2",
  null
  
)

export default component.exports